<template>
  <div class="function-page">
    <!-- 顶部功能按钮区 -->
    <div class="btn-group">
      <button
        class="func-btn"
        :class="{ active: route.name === 'Recharge' }"
        @click="goPage('Recharge')"
      >
        充值返利
      </button>

      <button
        class="func-btn"
        :class="{ active: route.name === 'Anchor' }"
        @click="goPage('Anchor')"
      >
        主播管理
      </button>

      <button
        class="func-btn"
        :class="{ active: route.name === 'Pray' }"
        @click="goPage('Pray')"
      >
        祈福控制
      </button>
    </div>

    <!-- 路由展示区域（点击按钮后，这里会显示对应页面） -->
    <div class="page-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

// 跳转路由
const goPage = (name) => {
  router.push({ name })
}
</script>

<style scoped>
.function-page {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.btn-group {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
}

.func-btn {
  padding: 12px 24px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  background: #f0f2f5;
  cursor: pointer;
  transition: all 0.3s;
}

.func-btn:hover {
  background: #e5e6eb;
}

.func-btn.active {
  background: #409eff;
  color: #fff;
}

.page-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  min-height: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
</style>